<template>
  <main>
    <div class="container-fluid bg-white pt-4">
      <div class="container">
        <share-portal-notification
          :name="name"
          :isvalid="isvalid"
        />
      </div>
    </div>
    <div class="container-fluid bg-white pt-4">
      <div class="container">
        <food-navbar
          source="share_portal"
          current="share-portal-profile"
        />
      </div>
    </div>
    <div
      v-if="isvalid"
      class="container-fluid bg-white py-4"
    >
      <div class="container">
        <vue-html2pdf
          v-show="current_view == 'main'"
          ref="profile"
          :html-to-pdf-options="{
            margin: 2,
            filename: 'Share-Portal-Profile-for'+name+'.pdf',
            jsPDF: {
              format: 'a3',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="1000"
          :pdf-quality="2"
          pdf-content-width="100%"
        >
          <section slot="pdf-content">
            <div class="share-portal-split">
              <div class="share-portal-side main">
                <div class="profile-box">
                  <div class="stat-section">
                    <div class="stat-split">
                      <div class="side">
                        <div class="stat-block">
                          <div class="label">
                            Name
                          </div>
                          <div class="value">
                            {{ name }}
                          </div>
                        </div>
                      </div>
                      <div class="side">
                        <div class="stat-block">
                          <div class="label">
                            Birthday
                          </div>
                          <div class="value">
                            {{ birthday }}
                          </div>
                        </div>
                      </div>
                      <div class="side">
                        <a
                          href="#"
                          class="download"
                          @click="generate_pdf('profile')"
                        ><i class="fas fa-cloud-download-alt" /> Download</a>
                      </div>
                    </div>
                  </div>
                  <div class="stat-section">
                    <div class="stat-split">
                      <div class="side">
                        <div class="line-items">
                          <div class="line-item">
                            <div class="label">
                              FOOD SPIRAL &reg;
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ food_spiral }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Fitness Level
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ fitness_level }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Fitness Goal
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ fitness_goal }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Weight Loss Goal
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ weight_goal }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Weight to Lose
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ weight_difference }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Fluid Goal
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ fluid_goal }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="side">
                        <div class="stat-block">
                          <div class="label">
                            Favorable Fitness Factor®
                          </div>
                          <div class="value">
                            {{ favorable_fitness_factor }}
                          </div>
                        </div>
                        <div class="stat-block">
                          <div class="label">
                            Individual Factor
                          </div>
                          <div class="value">
                            {{ individual_factor }}
                          </div>
                        </div>
                        <div class="stat-block">
                          <div class="label">
                            Exercise Score
                          </div>
                          <div class="value">
                            {{ exercise_score }} out of 20
                          </div>
                        </div>
                        <div class="stat-block">
                          <div class="label">
                            Medications
                          </div>
                          <div class="value">
                            {{ medications }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="stat-section">
                    <div class="stat-split">
                      <div class="side">
                        <div class="line-items">
                          <div class="line-item">
                            <div class="label">
                              Sodium
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ sodium }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Potassium
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ potassium }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Phosphorus
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ phosphorus }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Magnesium
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ magnesium }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              SGOT/AST
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ sgot_ast }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Glucose
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ glucose }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Bone Density
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ bone_density }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Blood Pressure
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ blood_pressure }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="side">
                        <div class="line-items">
                          <div class="line-item">
                            <div class="label">
                              SGPT/ALT
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ sgpt_alt }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Cholesterol
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ cholesterol }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              HDL
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ hdl }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              LDL
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ ldl }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              Triglycerides
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ triglycerides }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              BUN
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ bun }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="side">
                        <div class="line-items">
                          <div class="line-item">
                            <div class="label">
                              Creatinine
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ creatinine }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              BUN/C
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ bun_creatinine }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              HGB
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ hgb }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              HCT
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ hct }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              HGBA1C
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ hgba1c }}
                            </div>
                          </div>
                          <div class="line-item">
                            <div class="label">
                              TSH
                            </div>
                            <div class="space" />
                            <div class="value">
                              {{ tsh }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="share-portal-side sidebar">
                <div class="sidebar-card">
                  <h2>
                    <span>Weight</span>
                    <a
                      class="action details"
                      @click.prevent="current_view = 'weight'"
                    ><i class="fas fa-search" /> &nbsp;View Full</a>
                  </h2>
                  <div class="stats">
                    <div class="side">
                      <strong>Starting:</strong> {{ weight_chart_data.start_weight }}
                    </div>
                    <div class="side">
                      <strong>Current:</strong> {{ weight_chart_data.end_weight }}
                    </div>
                  </div>
                  <div class="chart-container">
                    <profile-weight-chart
                      :chart_labels="weight_chart_data.chart_labels"
                      :chart_datasets="weight_chart_data.chart_datasets"
                    />
                  </div>
                </div>

                <div class="sidebar-card">
                  <h2>
                    <span>Blood Pressure</span>
                    <a
                      class="action details"
                      @click.prevent="current_view = 'blood_pressure'"
                    ><i class="fas fa-search" /> &nbsp;View Full</a>
                  </h2>
                  <div class="stats">
                    <div class="side">
                      <strong>Starting:</strong> {{ blood_pressure_chart_data.start_bp }}
                    </div>
                    <div class="side">
                      <strong>Current:</strong> {{ blood_pressure_chart_data.end_bp }}
                    </div>
                  </div>
                  <div class="chart-container">
                    <profile-blood-pressure-chart
                      :chart_labels="blood_pressure_chart_data.chart_labels"
                      :chart_datasets="blood_pressure_chart_data.chart_datasets"
                    />
                  </div>
                </div>

                <div
                  v-if="['Renal Diabetes', 'Diabetes', 'Carb Counting'].includes(food_spiral)"
                  class="sidebar-card"
                >
                  <h2>
                    <span>Blood Sugar</span>
                    <a
                      class="action details"
                      @click.prevent="current_view = 'blood_sugar'"
                    ><i class="fas fa-search" /> &nbsp;View Full</a>
                  </h2>
                  <div class="stats">
                    <div class="side">
                      <strong>Starting:</strong> {{ blood_sugar_chart_data.start_sugar }}
                    </div>
                    <div class="side">
                      <strong>Current:</strong> {{ blood_sugar_chart_data.end_sugar }}
                    </div>
                  </div>
                  <div class="chart-container">
                    <profile-blood-sugar-chart
                      :chart_labels="blood_sugar_chart_data.chart_labels"
                      :chart_datasets="blood_sugar_chart_data.chart_datasets"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>

        <vue-html2pdf
          v-show="current_view == 'weight'"
          ref="weightreport"
          :html-to-pdf-options="{
            margin: 8,
            filename: 'Full-Weight-Report-for-'+name+'.pdf',
            jsPDF: {
              format: 'a4',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="2000"
          :pdf-quality="2"
          pdf-content-width="100%"
        >
          <section slot="pdf-content">
            <!-- Weight Report -->
            <div
              id="weight-report"
              class="report-window py-5"
            >
              <a
                class="back-nav-simple"
                @click="current_view = 'main'"
              ><i class="fas fa-arrow-left" /> Back to Profile</a>
              <h1>View Full Weight Report</h1>
              <div class="meta-bar">
                <div class="split">
                  <div class="left">
                    Showing {{ date_friendly(weight_chart_data.from) }} - {{ date_friendly(weight_chart_data.to) }}
                  </div>
                  <div class="right">
                    <a
                      class="button tertiary"
                      href="#"
                      @click="generate_pdf('weightreport')"
                    ><i
                      class="fas fa-download"
                      aria-hidden="true"
                    />Download PDF</a>
                    <a
                      class="button"
                      @click="weight_chart_data.is_showing_filters = !weight_chart_data.is_showing_filters"
                    ><i
                      class="fas fa-calendar-day"
                      aria-hidden="true"
                    />Change Time Period</a>
                  </div>
                </div>
              </div>
              <div
                v-show="weight_chart_data.is_showing_filters"
                id="factor-averages-filters"
                class="chart-filters"
              >
                <h4>Change Time Period</h4>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="weight_chart_data.type"
                        type="radio"
                        name="weight_chart_data.type"
                        value="week"
                      > <strong>Show Week to Week:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <input
                        v-model="weight_chart_data.from"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('weight_chart_data.from')"
                      ></label>
                      <label>To: <input
                        v-model="weight_chart_data.to"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('weight_chart_data.to')"
                      ></label>
                    </div>
                  </div>
                </div>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="weight_chart_data.type"
                        type="radio"
                        name="weight_chart_data.type"
                        value="month"
                      > <strong>Show Month to Month:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <input
                        v-model="weight_chart_data.from"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('weight_chart_data.from')"
                      ></label>
                      <label>To: <input
                        v-model="weight_chart_data.to"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('weight_chart_data.to')"
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart-container">
                <profile-weight-chart
                  :chart_labels="weight_chart_data.chart_labels"
                  :chart_datasets="weight_chart_data.chart_datasets"
                />
              </div>
              <div class="data-container">
                <div class="split">
                  <div class="side left">
                    <div class="line-items">
                      <div class="line-item">
                        <div class="label">
                          Starting Weight
                        </div>
                        <div class="space" />
                        <div class="value">
                          {{ weight_chart_data.start_weight }}
                        </div>
                      </div>
                      <div class="line-item">
                        <div class="label">
                          Ending Weight
                        </div>
                        <div class="space" />
                        <div class="value">
                          {{ weight_chart_data.end_weight }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="side right">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">
                            Period
                          </th>
                          <th scope="col">
                            Average Weight
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="d in weight_chart_data.table_data">
                          <td>{{ d.month }}</td>
                          <td>{{ d.weight }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>

        <vue-html2pdf
          v-show="current_view == 'blood_pressure'"
          ref="bloodpressurereport"
          :html-to-pdf-options="{
            margin: 8,
            filename: 'Full-Blood-Pressure-Report-for-'+name+'.pdf',
            jsPDF: {
              format: 'a4',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="2000"
          :pdf-quality="2"
          pdf-content-width="100%"
        >
          <section slot="pdf-content">
            <!-- Blood Pressure Report -->
            <div
              id="blood-pressure-report"
              class="report-window py-5"
            >
              <a
                class="back-nav-simple"
                @click="current_view = 'main'"
              ><i class="fas fa-arrow-left" /> Back to Profile</a>
              <h1>View Full Blood Pressure Report</h1>
              <div class="meta-bar">
                <div class="split">
                  <div class="left">
                    Showing {{ date_friendly(blood_pressure_chart_data.from) }} - {{ date_friendly(blood_pressure_chart_data.to) }}
                  </div>
                  <div class="right">
                    <a
                      class="button tertiary"
                      href="#"
                      @click="generate_pdf('bloodpressurereport')"
                    ><i
                      class="fas fa-download"
                      aria-hidden="true"
                    />Download PDF</a>
                    <a
                      class="button"
                      @click="blood_pressure_chart_data.is_showing_filters = !blood_pressure_chart_data.is_showing_filters"
                    ><i
                      class="fas fa-calendar-day"
                      aria-hidden="true"
                    />Change Time Period</a>
                  </div>
                </div>
              </div>
              <div
                v-show="blood_pressure_chart_data.is_showing_filters"
                id="factor-averages-filters"
                class="chart-filters"
              >
                <h4>Change Time Period</h4>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="blood_pressure_chart_data.type"
                        type="radio"
                        name="blood_pressure_chart_data.type"
                        value="week"
                      > <strong>Show Week to Week:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <input
                        v-model="blood_pressure_chart_data.from"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_pressure_chart_data.from')"
                      ></label>
                      <label>To: <input
                        v-model="blood_pressure_chart_data.to"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_pressure_chart_data.to')"
                      ></label>
                    </div>
                  </div>
                </div>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="blood_pressure_chart_data.type"
                        type="radio"
                        name="blood_pressure_chart_data.type"
                        value="month"
                      > <strong>Show Month to Month:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <input
                        v-model="blood_pressure_chart_data.from"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_pressure_chart_data.from')"
                      ></label>
                      <label>To: <input
                        v-model="blood_pressure_chart_data.to"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_pressure_chart_data.to')"
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart-container">
                <profile-blood-pressure-chart
                  :chart_labels="blood_pressure_chart_data.chart_labels"
                  :chart_datasets="blood_pressure_chart_data.chart_datasets"
                />
              </div>
              <div class="data-container">
                <div class="split">
                  <div class="side left">
                    <div class="line-items">
                      <div class="line-item">
                        <div class="label">
                          Starting Pressure
                        </div>
                        <div class="space" />
                        <div class="value">
                          {{ blood_pressure_chart_data.start_bp }}
                        </div>
                      </div>
                      <div class="line-item">
                        <div class="label">
                          Ending Pressure
                        </div>
                        <div class="space" />
                        <div class="value">
                          {{ blood_pressure_chart_data.end_bp }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="side right">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">
                            Period
                          </th>
                          <th scope="col">
                            Average Pressure
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="d in blood_pressure_chart_data.table_data">
                          <td>{{ d.month }}</td>
                          <td>{{ d.bp }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>

        <vue-html2pdf
          v-show="current_view == 'blood_sugar'"
          ref="bloodsugarreport"
          :html-to-pdf-options="{
            margin: 8,
            filename: 'Full-Blood-Sugar-Report-for-'+name+'.pdf',
            jsPDF: {
              format: 'a4',
              orientation: 'landscape',
            }
          }"
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :manual-pagination="false"
          :paginate-elements-by-height="2000"
          :pdf-quality="2"
          pdf-content-width="100%"
        >
          <section slot="pdf-content">
            <!-- Blood Sugar Report -->
            <div
              id="blood-sugar-report"
              class="report-window py-5"
            >
              <a
                class="back-nav-simple"
                @click="current_view = 'main'"
              ><i class="fas fa-arrow-left" /> Back to Profile</a>
              <h1>View Full Blood Sugar Report</h1>
              <div class="meta-bar">
                <div class="split">
                  <div class="left">
                    Showing {{ date_friendly(blood_sugar_chart_data.from) }} - {{ date_friendly(blood_sugar_chart_data.to) }}
                  </div>
                  <div class="right">
                    <a
                      class="button tertiary"
                      href="#"
                      @click="generate_pdf('bloodsugarreport')"
                    ><i
                      class="fas fa-download"
                      aria-hidden="true"
                    />Download PDF</a>
                    <a
                      class="button"
                      @click="blood_sugar_chart_data.is_showing_filters = !blood_sugar_chart_data.is_showing_filters"
                    ><i
                      class="fas fa-calendar-day"
                      aria-hidden="true"
                    />Change Time Period</a>
                  </div>
                </div>
              </div>
              <div
                v-show="blood_sugar_chart_data.is_showing_filters"
                id="factor-averages-filters"
                class="chart-filters"
              >
                <h4>Change Time Period</h4>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="blood_sugar_chart_data.type"
                        type="radio"
                        name="blood_sugar_chart_data.type"
                        value="week"
                      > <strong>Show Week to Week:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <input
                        v-model="blood_sugar_chart_data.from"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_sugar_chart_data.from')"
                      ></label>
                      <label>To: <input
                        v-model="blood_sugar_chart_data.to"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_sugar_chart_data.to')"
                      ></label>
                    </div>
                  </div>
                </div>
                <div class="time-period-row">
                  <div class="split">
                    <div class="side label">
                      <label><input
                        v-model="blood_sugar_chart_data.type"
                        type="radio"
                        name="blood_sugar_chart_data.type"
                        value="month"
                      > <strong>Show Month to Month:</strong></label>
                    </div>
                    <div class="side input">
                      <label>From: <input
                        v-model="blood_sugar_chart_data.from"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_sugar_chart_data.from')"
                      ></label>
                      <label>To: <input
                        v-model="blood_sugar_chart_data.to"
                        type="date"
                        class="fff-ui"
                        @click.prevent="opencal('blood_sugar_chart_data.to')"
                      ></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart-container">
                <profile-blood-sugar-chart
                  :chart_labels="blood_sugar_chart_data.chart_labels"
                  :chart_datasets="blood_sugar_chart_data.chart_datasets"
                />
              </div>
              <div class="data-container">
                <div
                  v-for="bs in blood_sugar_chart_data.table_data"
                  class="table-responsive pt-3"
                >
                  <table class="table table-bordered table-small">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          rowspan="2"
                        >
                          {{ bs.date }}
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Sunday
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Monday
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Tuesday
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Wednesday
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Thursday
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Friday
                        </th>
                        <th
                          scope="col"
                          colspan="2"
                          class="text-center"
                        >
                          Saturday
                        </th>
                      </tr>
                      <tr>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          Before
                        </th>
                        <th
                          scope="col"
                          class="text-center"
                        >
                          After
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Breakfast</td>
                        <template v-for="d in bs.days">
                          <td class="text-center">
                            {{ (d.meal['breakfast - before'].length > 0 ? d.meal['breakfast - before'].join(', ') : '--') }}
                          </td>
                          <td class="text-center">
                            {{ (d.meal['breakfast - after'].length > 0 ? d.meal['breakfast - after'].join(', ') : '--') }}
                          </td>
                        </template>
                      </tr>
                      <tr>
                        <td>Lunch</td>
                        <template v-for="d in bs.days">
                          <td class="text-center">
                            {{ (d.meal['lunch - before'].length > 0 ? d.meal['lunch - before'].join(', ') : '--') }}
                          </td>
                          <td class="text-center">
                            {{ (d.meal['lunch - after'].length > 0 ? d.meal['lunch - after'].join(', ') : '--') }}
                          </td>
                        </template>
                      </tr>
                      <tr>
                        <td>Dinner</td>
                        <template v-for="d in bs.days">
                          <td class="text-center">
                            {{ (d.meal['dinner - before'].length > 0 ? d.meal['dinner - before'].join(', ') : '--') }}
                          </td>
                          <td class="text-center">
                            {{ (d.meal['dinner - after'].length > 0 ? d.meal['dinner - after'].join(', ') : '--') }}
                          </td>
                        </template>
                      </tr>
                      <tr>
                        <td>Bedtime</td>
                        <template v-for="d in bs.days">
                          <td
                            colspan="2"
                            class="text-center"
                          >
                            {{ (d.meal['bedtime'].length > 0 ? d.meal['bedtime'].join(', ') : '--') }}
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>

        <!-- Date Modal -->
        <date-modal
          v-show="is_showing_date_modal"
          :thedate="selecteddate"
          :theinput="selectedinput"
          :hidenav="hidenav"
          @hide-modal="is_showing_date_modal = false"
          @choose-input="update_input"
        />
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
import ProfileWeightChart from '../components/ProfileWeightChart.js'
import ProfileBloodPressureChart from '../components/ProfileBloodPressureChart.js'
import ProfileBloodSugarChart from '../components/ProfileBloodSugarChart.js'

export default {
  name: 'SharePortalProfile',
  components: {
    ProfileWeightChart,
    ProfileBloodPressureChart,
    ProfileBloodSugarChart,
    VueHtml2pdf
  },
  data() {
    return {
      isvalid:true,
      current_view: 'main',
      name: '...',
      birthday: '...',
      food_spiral: '...',
      food_factor: '...',
      favorable_fitness_factor: '...',
      individual_factor: '...',
      fitness_level: '...',
      fitness_goal: '...',
      weight_difference: '...',
      weight_goal: '...',
      fluid_goal: '...',
      exercise_score: '...',
      medications: '...',
      sodium: '...',
      sgpt_alt: '...',
      creatinine: '...',
      potassium: '...',
      cholesterol: '...',
      bun_creatinine: '...',
      phosphorus: '...',
      hdl: '...',
      hgb: '...',
      magnesium: '...',
      ldl: '...',
      hct: '...',
      sgot_ast: '...',
      triglycerides: '...',
      hgba1c: '...',
      glucose: '...',
      bun: '...',
      tsh: '...',
      bone_density: '...',
      blood_pressure: '...',

      // Charts
      weight_chart_data: {
        chart_labels: [],
        chart_datasets: [
          {
            data: [],
            borderColor: 'rgba(95, 159, 59, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(95, 159, 59, 1)',
          },
        ],
        type: 'week',
        from: moment().startOf('year').format('YYYY-MM-DD'),
        to: moment().endOf('year').format('YYYY-MM-DD'),
        table_data:[],
        start_weight:'',
        end_weight:'',
        is_showing_filters: false,
      },
      blood_pressure_chart_data: {
        chart_labels: [],
        chart_datasets: [
          {
            label: 'Lower',
            data: [],
            borderColor: 'rgba(121, 0, 0, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(121, 0, 0, 1)',
          },
          {
            label: 'Upper',
            data: [],
            borderColor: 'rgba(198, 30, 36, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(198, 30, 36, 1)',
          },
        ],
        type: 'week',
        from: moment().startOf('year').format('YYYY-MM-DD'),
        to: moment().endOf('year').format('YYYY-MM-DD'),
        table_data:[],
        start_bp:'',
        end_bp:'',
        is_showing_filters: false,
      },
      blood_sugar_chart_data: {
        chart_labels: [],
        chart_datasets: [
          {
            label: 'Average',
            data: [],
            borderColor: 'rgba(185, 152, 0, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(185, 152, 0, 1)',
          },
          {
            label: 'Min',
            data: [],
            borderColor: 'rgba(238, 197, 11, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(238, 197, 11, 1)',
          },{
            label: 'Max',
            data: [],
            borderColor: 'rgba(198, 30, 36, 1)',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(198, 30, 36, 1)',
          },
        ],
        type: 'week',
        from: moment().startOf('year').format('YYYY-MM-DD'),
        to: moment().endOf('year').format('YYYY-MM-DD'),
        table_data:[],
        start_sugar:'',
        end_sugar:'',
        is_showing_filters: false,
      },
      hidenav:'hide',
      months:['January','February','March','April','May','June','July','August','September','October','November','December'],
      selecteddate:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1).split('T')[0],
      selectedinput:'',
      is_showing_date_modal: false,
    };
  },
  computed: {

  },
  watch: {
    'weight_chart_data.type': function(){this.fetch_weight_data()},
    'weight_chart_data.to': function(){this.fetch_weight_data()},
    'weight_chart_data.from': function(){this.fetch_weight_data()},
    'blood_pressure_chart_data.type': function(){this.fetch_blood_pressure_data()},
    'blood_pressure_chart_data.to': function(){this.fetch_blood_pressure_data()},
    'blood_pressure_chart_data.from': function(){this.fetch_blood_pressure_data()},
    'blood_sugar_chart_data.type': function(){this.fetch_blood_sugar_data()},
    'blood_sugar_chart_data.to': function(){this.fetch_blood_sugar_data()},
    'blood_sugar_chart_data.from': function(){this.fetch_blood_sugar_data()},
  },
  async mounted() {
    this.load_profile();
    this.fetch_weight_data();
    this.fetch_blood_pressure_data();
    this.fetch_blood_sugar_data();
  },
  methods: {
    moment() {
      return moment();
    },
    date_friendly(d) {
      return moment(d).format('MMMM Do YYYY');
    },
    async load_profile(){
      // Profile
      let get_profile = await this.$http('/api/share-portal/profile', {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });

      if(get_profile.message == "Invalid."){
        this.isvalid=false;
        return false;
      }
      let fetch_profile = get_profile.data;
      if (typeof(fetch_profile) != 'undefined') {
        this.name = fetch_profile.name;
        this.birthday = fetch_profile.birthday;
        this.food_spiral = fetch_profile.spiral_name;
        this.favorable_fitness_factor = fetch_profile.favorable_fitness_factor;
        this.individual_factor = fetch_profile.individual_factor;
        this.fitness_level = fetch_profile.fitness_level;
        this.fitness_goal = fetch_profile.fitness_goal;
        this.weight_goal = fetch_profile.fitness_target_goal;
        this.weight_difference = fetch_profile.fitness_weight_difference;
        this.fluid_goal = (fetch_profile.fluid_goal / 236.5882375).toFixed(2) + ' cups/day';
        this.exercise_score = fetch_profile.exercise_score;
        this.medications = fetch_profile.medications;
        this.sodium = fetch_profile.lab.sodium;
        this.sgpt_alt = fetch_profile.lab.sgpt_alt;
        this.creatinine = fetch_profile.lab.creatinine;
        this.potassium = fetch_profile.lab.potassium;
        this.cholesterol = fetch_profile.lab.cholesterol;
        this.bun_creatinine = fetch_profile.lab.bun_to_creatinine;
        this.phosphorus = fetch_profile.lab.phosphorus;
        this.hdl = fetch_profile.lab.hdl;
        this.hgb = fetch_profile.lab.hgb;
        this.magnesium = fetch_profile.lab.magnesium;
        this.ldl = fetch_profile.lab.ldl;
        this.hct = fetch_profile.lab.hct;
        this.sgot_ast = fetch_profile.lab.sgot_ast;
        this.triglycerides = fetch_profile.lab.triglycerides;
        this.hgba1c = fetch_profile.lab.hgba1c;
        this.glucose = fetch_profile.lab.glucose;
        this.bun = fetch_profile.lab.bun;
        this.tsh = fetch_profile.lab.tsh;
        this.bone_density = fetch_profile.lab.bone_density;
        this.blood_pressure = fetch_profile.lab.blood_pressure.systolic + '/' + fetch_profile.lab.blood_pressure.diastolic;
        this.blood_pressure_current = fetch_profile.lab.blood_pressure.systolic + '/' + fetch_profile.lab.blood_pressure.diastolic;
      }

    },
    async fetch_weight_data() {
      // Build query string from object
      var params = {
        period: this.weight_chart_data.type,
        date_from: this.weight_chart_data.from,
        date_to: this.weight_chart_data.to,
      };
      var esc = encodeURIComponent;
      var query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');

      // Fetch data
      let fetch_weight = await this.$http('/api/share-portal/weighthistory' + query, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });
      if (typeof(fetch_weight) != 'undefined') {
        // Build it into graphs and tables
        // Each object inside is a data point
        this.weight_chart_data.chart_datasets[0].data = [];
        this.weight_chart_data.chart_datasets[0].borderColor= 'rgba(95, 159, 59, 1)';
        this.weight_chart_data.chart_datasets[0].backgroundColor= 'rgba(0, 0, 0, 0)';
        this.weight_chart_data.chart_datasets[0].pointBackgroundColor= 'rgba(95, 159, 59, 1)';

        this.weight_chart_data.chart_labels = [];
        this.weight_chart_data.table_data = [];
        for (var p in fetch_weight.period_items) {
          if (fetch_weight.period_items.hasOwnProperty(p)) {
            var point = fetch_weight.period_items[p];
            if(this.weight_chart_data.type=='month'){
              let monthname = this.cleanmonth(point.date_from.date);
              this.weight_chart_data.table_data.push({'month':monthname ,'weight':(point.average>0?point.average:'--')});
            }
            if(point.average!=0){
              if(this.weight_chart_data.type=='week'){
                this.weight_chart_data.table_data.push({'month':"Week of "+point.date_from_simple ,'weight':point.average});
              }
              this.weight_chart_data.chart_datasets[0].data.push(point.average);
              this.weight_chart_data.chart_labels.push(point.date_from_simple);
            }
          }
        }
        this.weight_chart_data.start_weight = fetch_weight.summary_items.starting.weight;
        this.weight_chart_data.end_weight = fetch_weight.summary_items.ending.weight;

        console.log("weight data",this);
        console.log(this.weight_chart_data.chart_datasets);
        console.log(this.weight_chart_data.chart_labels);
      }
    },
    async fetch_blood_pressure_data() {
      // Build query string from object
      var params = {
        period: this.blood_pressure_chart_data.type,
        date_from: this.blood_pressure_chart_data.from,
        date_to: this.blood_pressure_chart_data.to,
      };
      var esc = encodeURIComponent;
      var query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');

      // Fetch data
      let fetch_bp = await this.$http('/api/share-portal/bloodpressurehistory' + query, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });
      if (typeof(fetch_bp) != 'undefined') {
        // Build it into graphs and tables
        // Each object inside is a data point
        this.blood_pressure_chart_data.chart_datasets[0].data = [];
        this.blood_pressure_chart_data.chart_datasets[0].borderColor= 'rgba(95, 159, 59, 1)';
        this.blood_pressure_chart_data.chart_datasets[0].backgroundColor= 'rgba(0, 0, 0, 0)';
        this.blood_pressure_chart_data.chart_datasets[0].pointBackgroundColor= 'rgba(95, 159, 59, 1)';

        this.blood_pressure_chart_data.chart_datasets[1].data = [];
        this.blood_pressure_chart_data.chart_datasets[1].borderColor= 'rgba(121, 0, 0, 1)';
        this.blood_pressure_chart_data.chart_datasets[1].backgroundColor= 'rgba(0, 0, 0, 0)';
        this.blood_pressure_chart_data.chart_datasets[1].pointBackgroundColor= 'rgba(121, 0, 0, 1)';

        this.blood_pressure_chart_data.chart_labels = [];
        this.blood_pressure_chart_data.table_data = [];
        for (var p in fetch_bp.period_items) {
          if (fetch_bp.period_items.hasOwnProperty(p)) {
            var point = fetch_bp.period_items[p];
            if(this.blood_pressure_chart_data.type=='month'){
              let monthname = this.cleanmonth(point.date_from.date);
              this.blood_pressure_chart_data.table_data.push({'month':monthname ,'bp':(point.data.diastolic.average>0?point.data.systolic.average+'/'+point.data.diastolic.average:'--/--')});
            }
            if(point.data.systolic.average!=0){
              if(this.blood_pressure_chart_data.type=='week'){
                this.blood_pressure_chart_data.table_data.push({'month':"Week of "+point.date_from_simple ,'bp':point.data.systolic.average+'/'+point.data.diastolic.average});
              }
              this.blood_pressure_chart_data.chart_datasets[0].data.push(point.data.systolic.average);
              this.blood_pressure_chart_data.chart_datasets[1].data.push(point.data.diastolic.average);
              this.blood_pressure_chart_data.chart_labels.push(point.date_from_simple);
            }
          }
        }
        this.blood_pressure_chart_data.start_bp = fetch_bp.summary_items.starting.systolic+'/'+fetch_bp.summary_items.starting.diastolic;
        this.blood_pressure_chart_data.end_bp = fetch_bp.summary_items.ending.systolic+'/'+fetch_bp.summary_items.ending.diastolic;

        console.log("blood pressure data",this);
        console.log(this.blood_pressure_chart_data.chart_datasets);
        console.log(this.blood_pressure_chart_data.chart_labels);
      }
    },
    async fetch_blood_sugar_data() {
      // Build query string from object
      var params = {
        period: this.blood_sugar_chart_data.type,
        date_from: this.blood_sugar_chart_data.from,
        date_to: this.blood_sugar_chart_data.to,
      };
      var esc = encodeURIComponent;
      var query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');

      // Fetch data
      let fetch_sugar = await this.$http('/api/share-portal/bloodsugarhistory' + query, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });
      if (typeof(fetch_sugar) != 'undefined') {
        // Build it into graphs and tables
        // Each object inside is a data point
        this.blood_sugar_chart_data.chart_datasets[0].data = [];
        this.blood_sugar_chart_data.chart_datasets[0].borderColor= 'rgba(185, 152, 0, 1)';
        this.blood_sugar_chart_data.chart_datasets[0].backgroundColor= 'rgba(0, 0, 0, 0)';
        this.blood_sugar_chart_data.chart_datasets[0].pointBackgroundColor= 'rgba(185, 152, 0, 1)';

        this.blood_sugar_chart_data.chart_datasets[1].data = [];
        this.blood_sugar_chart_data.chart_datasets[1].borderColor= 'rgba(238, 197, 11, 1)';
        this.blood_sugar_chart_data.chart_datasets[1].backgroundColor= 'rgba(0, 0, 0, 0)';
        this.blood_sugar_chart_data.chart_datasets[1].pointBackgroundColor= 'rgba(238, 197, 11, 1)';

        this.blood_sugar_chart_data.chart_datasets[2].data = [];
        this.blood_sugar_chart_data.chart_datasets[2].borderColor= 'rgba(121, 0, 0, 1)';
        this.blood_sugar_chart_data.chart_datasets[2].backgroundColor= 'rgba(0, 0, 0, 0)';
        this.blood_sugar_chart_data.chart_datasets[2].pointBackgroundColor= 'rgba(121, 0, 0, 1)';

        this.blood_sugar_chart_data.chart_labels = [];
        this.blood_sugar_chart_data.table_data = [];
        for (var p in fetch_sugar.period_items) {
          if (fetch_sugar.period_items.hasOwnProperty(p)) {
            var point = fetch_sugar.period_items[p];

            if(point.data.summary.average!=0){
              if(this.blood_sugar_chart_data.type=='month'){
                let monthname = this.cleanmonth(point.date_from.date);
                //this.blood_sugar_chart_data.table_data.push({'date':monthname ,'days':point.data.entries_table});
              }

              if(this.blood_sugar_chart_data.type=='week'){
                this.blood_sugar_chart_data.table_data.push({
                  'date':"Week of "+point.date_from_simple ,
                  'days':point.data.entries_table}
                );
              }
              this.blood_sugar_chart_data.chart_datasets[0].data.push(point.data.summary.average);
              this.blood_sugar_chart_data.chart_datasets[1].data.push(point.data.summary.min);
              this.blood_sugar_chart_data.chart_datasets[2].data.push(point.data.summary.max);
              this.blood_sugar_chart_data.chart_labels.push(point.date_from_simple);
            }
          }
        }
        this.blood_sugar_chart_data.start_sugar = fetch_sugar.summary_items.starting.value;
        this.blood_sugar_chart_data.end_sugar = fetch_sugar.summary_items.ending.value;

        console.log("blood sugar data",this);
        console.log(this.blood_sugar_chart_data.chart_datasets);
        console.log(this.blood_sugar_chart_data.chart_labels);
      }
    },
    cleanmonth(date){
      let months = {
        '01':'January',
        '02':'February',
        '03':'March',
        '04':'April',
        '05':'May',
        '06':'June',
        '07':'July',
        '08':'August',
        '09':'September',
        '10':'October',
        '11':'November',
        '12':'December'
      }
      let monthnum = date.split('-')[1]; //Expecting it to look like: 2020-01-01 00:00:00.000000
      return months[monthnum];
    },
    generate_pdf(name){
      // Scroll to top and close filters
      window.scrollTo(0, 0);
      this.weight_chart_data.is_showing_filters = false;
      this.blood_pressure_chart_data.is_showing_filters = false;
      this.blood_sugar_chart_data.is_showing_filters = false;

      // Generate
      this.$refs[name].generatePdf();
    },
    opencal(elementname){
      this.selectedinput = elementname;
      let split = elementname.split(".");
      this.selecteddate = this[split[0]][split[1]];
      this.is_showing_date_modal = true;
    },
    update_input(info){
      console.log('info');
      console.log(info);
      let split = info.elementname.split(".");
      this[split[0]][split[1]] = info.date;
      //this.load_section();
    },
  },
};
</script>
